module.exports = __webpack_public_path__ + "static/media/bg.e4093c9e.jpg";